import { storyArc } from "@/mocks/comicData";

const arcImages = [
  "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20illustration%20of%20a%20young%20doctor%20walking%20through%20an%20ancient%20jianghu%20village%20with%20jade%20green%20and%20cinnabar%20red%20tones%2C%20elegant%20traditional%20style&width=800&height=600&seq=arc-01-001&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20illustration%20of%20a%20mysterious%20herb%20valley%20with%20spirit%20beasts%20and%20medicinal%20plants%2C%20jade%20green%20misty%20mountains%2C%20elegant%20traditional%20style&width=800&height=600&seq=arc-02-001&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20illustration%20of%20a%20grand%20immortal%20doctor%20assembly%20hall%20with%20crowds%20and%20banners%2C%20cinnabar%20red%20and%20gold%20accents%2C%20elegant%20traditional%20style&width=800&height=600&seq=arc-03-001&orientation=landscape",
  "https://readdy.ai/api/search-image?query=Chinese%20ink%20wash%20illustration%20of%20a%20heroic%20immortal%20doctor%20returning%20to%20a%20mountaintop%20with%20herbs%20and%20clouds%2C%20warm%20light%2C%20jade%20green%20and%20cinnabar%20red%2C%20elegant%20traditional%20style&width=800&height=600&seq=arc-04-001&orientation=landscape",
];

export default function StoryIntro() {
  return (
    <section id="story" className="w-full py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">
            <i className="ri-quill-pen-line"></i>剧情简介
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            天才医仙 · 以银针济苍生
          </h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-600">
            天赋异禀的年轻医者沈星澜，凭一手出神入化的银针行走乱世，行医济世、揭开身世之谜，在医道争锋中一步步踏上真正的医仙之路。
          </p>
        </div>

        <div className="mt-10 grid gap-5 sm:grid-cols-2">
          {storyArc.map((arc, i) => (
            <article key={arc.key} className="flex flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100/50 sm:flex-row">
              <div className="h-40 w-full shrink-0 overflow-hidden sm:h-auto sm:w-48">
                <img
                  src={arcImages[i]}
                  alt={`天才医仙剧情${arc.title}`}
                  title={`天才医仙漫画 ${arc.title}`}
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <div className="flex flex-1 flex-col justify-center p-5">
                <span className="font-heading text-xs font-bold text-accent-600">章节 {arc.key}</span>
                <h3 className="mt-1 font-heading text-lg font-bold text-foreground-950">{arc.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-foreground-600">{arc.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}